import { render } from "./PosteLettrePage.vue?vue&type=template&id=eb0297ee"
import script from "./PosteLettrePage.vue?vue&type=script&lang=js"
export * from "./PosteLettrePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__